import { TypeBase } from '../../baseTypes/TypeBase';
import { BlockInstanceType } from '../../blocks/BlockInterface';
import { BlockRegistry } from './blockRegistry';
import { BlockPropertyTypeFilterPredicate } from './types';

export class BlockPropertyTypeIsWhitelistedFilterPredicate
  implements BlockPropertyTypeFilterPredicate
{
  private whitelistedBlockPropertyTypeNames: ReadonlyArray<string>;

  constructor(
    whitelistedBlockPropertyTypes: ReadonlyArray<TypeBase<any>>,
    private blockRegistry: BlockRegistry
  ) {
    this.whitelistedBlockPropertyTypeNames = whitelistedBlockPropertyTypes.map(
      type => type.name
    );
  }

  shouldAllowBlockPropertyType(
    block: BlockInstanceType,
    blockPropertyName: string
  ): boolean {
    const blockType = this.blockRegistry.getBlockType(block.blockId!);

    return (
      blockPropertyName in block.properties &&
      this.whitelistedBlockPropertyTypeNames.includes(
        blockType.properties[blockPropertyName]?.type!
      )
    );
  }
}
